import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { deepExtract } from 'helpers/deep';
import { extractRafRewards } from 'components/Friendbuy/FriendbuyWidget';
import { ProductLinks } from '../NavItems/ProductLinks';
import { RafNavItem } from '../NavItems/RafNavItem';
import { UpcomingNavItem } from '../NavItems/UpcomingNavItem';
export var ActiveUserNav = function ActiveUserNav(_ref) {
  var isLivePage = _ref.isLivePage,
      isGoPage = _ref.isGoPage,
      user = _ref.user;

  var _extractRafRewards = extractRafRewards(user),
      rafSenderReward = _extractRafRewards.rafSenderReward;

  return React.createElement(Fragment, null, !isLivePage && !isGoPage && React.createElement(ProductLinks, null), React.createElement(UpcomingNavItem, {
    count: deepExtract('reservation_info.upcoming_reservation_count', user, 0)
  }), rafSenderReward && React.createElement(RafNavItem, {
    reward: rafSenderReward,
    user: user
  }));
};
ActiveUserNav.propTypes = {
  isLivePage: PropTypes.bool,
  isGoPage: PropTypes.bool,
  user: PropTypes.object.isRequired
};